import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { scheduleGa4ScriptLoad } from './utils/analytics';
import App from './App';
import './styles/index.css';

scheduleGa4ScriptLoad();

const root = createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
